import { Component } from "react";
import {
  Map,
  Source,
  Layer,
  Marker,
  FullscreenControl,
  NavigationControl,
} from "@vis.gl/react-maplibre";
import "maplibre-gl/dist/maplibre-gl.css";
import withRouter from "../withRouter";
import { StoreContext } from "../store/RootStore";
import { observer } from "mobx-react";
import maplibregl from "maplibre-gl";
import * as turf from "@turf/turf";
import moment from "moment";

import locationPin from "../assets/images/location-pin.png";

import { googleProtocol, createGoogleStyle } from "maplibre-google-maps";
import { FaSatellite } from "react-icons/fa";
// import MapboxDraw from "@mapbox/mapbox-gl-draw";
// import { Map, useControl } from "@vis.gl/react-maplibre";
import DrawControl from "./DrawControl";
import config from "../config";
import { text } from "d3";
import LiveTrackingStore from "../store/LiveTrackingStore";
import { Button, Spin, Tooltip } from "antd";
// import PegmanControl from "./PegmanControl";

import { StreetViewControl } from "maplibre-gl-streetview";
import "maplibre-gl-streetview/style.css";

const vehicleLayer = {
  id: "vehicles",
  type: "circle",
  paint: {
    "circle-radius": 6,
    "circle-color": "#007cbf",
    "circle-stroke-width": 1,
    "circle-stroke-color": "#fff",
  },
};

const clusterLayer = {
  id: "clusters",
  type: "symbol",
  source: "vehicle-source",
  filter: ["has", "point_count"],
  layout: {
    "icon-image": [
      "let",
      "hasR",
      [">", ["to-number", ["coalesce", ["get", "running"], 0]], 0],
      "hasI",
      [">", ["to-number", ["coalesce", ["get", "idle"], 0]], 0],
      "hasS",
      [">", ["to-number", ["coalesce", ["get", "stopped"], 0]], 0],
      "hasN",
      [">", ["to-number", ["coalesce", ["get", "nodata"], 0]], 0],
      [
        "case",
        // Match the exact filename IDs being added to the map
        [
          "all",
          ["var", "hasR"],
          ["var", "hasI"],
          ["var", "hasS"],
          ["var", "hasN"],
        ],
        "15.png",

        ["all", ["var", "hasR"], ["var", "hasI"], ["var", "hasS"]],
        "12.png",
        ["all", ["var", "hasR"], ["var", "hasI"], ["var", "hasN"]],
        "11.png",
        ["all", ["var", "hasI"], ["var", "hasS"], ["var", "hasN"]],
        "11.png",

        ["all", ["var", "hasS"], ["var", "hasI"]],
        "8.png",
        ["all", ["var", "hasR"], ["var", "hasS"]],
        "10.png",
        ["all", ["var", "hasR"], ["var", "hasI"]],
        "9.png",

        ["all", ["var", "hasS"], ["var", "hasN"]],
        "6.png",
        ["all", ["var", "hasR"], ["var", "hasN"]],
        "7.png",
        ["all", ["var", "hasI"], ["var", "hasN"]],
        "5.png",

        ["var", "hasR"],
        "4.png",
        ["var", "hasI"],
        "2.png",
        ["var", "hasS"],
        "3.png",
        ["var", "hasN"],
        "nodata.png",
        "1.png", // Fallback
      ],
    ],
    "icon-size": 1,
    "icon-allow-overlap": true,
    "icon-ignore-placement": true, // REQUIRED: Don't hide for other labels
  },

  paint: {
    "icon-opacity": 1,
  },
};
// 2. The Text Count Layer (Simplified for readability inside the ring)
const clusterCountLayer = {
  id: "cluster-count",
  type: "symbol",
  source: "vehicle-source",
  filter: ["has", "point_count"],
  layout: {
    "text-field": ["get", "point_count_abbreviated"],
    "text-font": ["calibri"],
    "text-size": 12,
    "text-allow-overlap": true,
  },
  paint: {
    "text-color": "#000000",
    "text-halo-color": "#ffffff",
    "text-halo-width": 0.2,
  },
};

const loadClusterImages = (map) => {
  console.log("in load cluster images");

  const ids = [
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "10",
    "11",
    "12",
    "13",
    "14",
    "nodata",
  ];

  ids.forEach((num) => {
    const id = `${num}.png`;
    const url = `/clusterimages/${id}`;
    console.log(url);

    map.loadImage(url, (err, image) => {
      console.log("in loadeimages");

      if (err || !image) {
        console.error("Failed to load", id);
        return;
      }

      if (!map.hasImage(id)) {
        map.addImage(id, image, {
          pixelRatio: window.devicePixelRatio || 1,
        });
        console.log("✅ Added", id);
      }
    });
  });
};

const unclusteredPointLayer = {
  id: "vehicles",
  type: "symbol", // Changed from circle to symbol
  source: "vehicle-source",
  filter: ["!", ["has", "point_count"]],
  layout: {
    // This 'mapImage' comes from your GeoJSON properties
    // "icon-image": ["get", "mapImage"],
    "icon-image": ["coalesce", ["get", "mapImage"], "arrow"],
    "icon-rotate": ["get", "rotation"],
    "icon-rotation-alignment": "map",
    "icon-size": 0.5,
    "icon-allow-overlap": true,
    "icon-allow-overlap": true, // CRITICAL: Shows icon even if labels are there
    "icon-ignore-placement": true, // CRITICAL: Labels won't hide for this icon
    "text-allow-overlap": true,
    "icon-anchor": "bottom", // Aligns the "feet" of the car/pin to the coord
    visibility: "visible",
  },
};

const moveVehiclesToTop = (map) => {
  const vehicleLayers = ["vehicles", "clusters", "cluster-count"];
  vehicleLayers.forEach((layerId) => {
    if (map.getLayer(layerId)) {
      map.moveLayer(layerId); // This moves the layer to the very top of the stack
    }
  });
};

const searchAssetLayer = {
  id: "vehicles",
  type: "symbol",
  source: "vehicle-source",
  filter: ["!", ["has", "point_count"]],
  layout: {
    "icon-image": ["coalesce", ["get", "mapImage"], "arrow"],
    "icon-rotate": ["get", "rotation"],
    "icon-rotation-alignment": "map",
    "icon-size": 0.3,
    "icon-allow-overlap": true,

    // UNCOMMENT THIS: Combine vehicleNo and name permanently
    "text-field": ["concat", ["get", "vehicleNo"], "/", ["get", "name"]],
    "text-font": ["sans-serif"],
    "text-size": 11,
    "text-offset": [0, 1.4], // Position above the icon
    "text-anchor": "top",
    "text-allow-overlap": true, // Allow labels to show even if they overlap slightly
  },
  paint: {
    // Style the text with a bright green "halo" to create the box background effect
    "text-color": "#000000",
    "text-halo-color": "#00ff00", // Matches your desired green background color
    "text-halo-width": 8, // Controls the size of the "box" around the text
    "text-halo-blur": 0, // Keep halo sharp (no blur)
  },
};

const poiLayer = {
  id: "pois",
  type: "symbol",
  source: "poi-source",
  filter: ["!", ["has", "point_count"]],
  layout: {
    "icon-image": ["coalesce", ["get", "mapImage"], "arrow"],
    "icon-rotate": ["get", "rotation"],
    "icon-rotation-alignment": "map",
    "icon-size": 0.5,
    "icon-allow-overlap": true,

    // UNCOMMENT THIS: Combine vehicleNo and name permanently
    // "text-field": ["concat", ["get", "vehicleNo"], "/", ["get", "name"]],
    "text-field": ["get", "poitext"],
    "text-font": ["sans-serif"],
    "text-size": 13,
    "text-offset": [0, 2.2], // Position above the icon
    "text-anchor": "top",
    "text-allow-overlap": true, // Allow labels to show even if they overlap slightly
  },
  paint: {
    "text-color": "#000",
    "text-halo-color": "#fff",
    "text-halo-width": 2,
  },
  // paint: {
  //   // Style the text with a bright green "halo" to create the box background effect
  //   "text-color": "#000000",
  //   "text-halo-color": "#00ff00", // Matches your desired green background color
  //   "text-halo-width": 8, // Controls the size of the "box" around the text
  //   "text-halo-blur": 0, // Keep halo sharp (no blur)
  // },
};

const BALLOON_ICON_SET = new Set([
  "gray-east",
  "gray-north",
  "gray-north-east",
  "gray-north-west",
  "gray-south",
  "gray-south-east",
  "gray-south-west",
  "gray-west",

  "Green-east",
  "Green-north",
  "Green-north-east",
  "Green-north-west",
  "Green-south",
  "Green-south-east",
  "Green-south-west",
  "Green-west",

  "Red-east",
  "Red-north",
  "Red-north-east",
  "Red-north-west",
  "Red-south",
  "Red-south-east",
  "Red-south-west",
  "Red-west",

  "Yellow-east",
  "Yellow-north",
  "Yellow-north-east",
  "Yellow-north-west",
  "Yellow-south",
  "Yellow-south-east",
  "Yellow-south-west",
  "Yellow-west",

  "Orange-east",
  "Orange-north",
  "Orange-north-east",
  "Orange-north-west",
  "Orange-south",
  "Orange-south-east",
  "Orange-south-west",
  "Orange-west",
]);

const onMapLoad = (mapRef, mapType) => {
  console.log(mapType, "qswdefgrthyujki");
  const map = mapRef;

  // ---- GOOGLE ----
  map.addSource("google", {
    type: "raster",
    tiles: ["https://mt1.google.com/vt/lyrs=m&x={x}&y={y}&z={z}"],
    tileSize: 256,
  });

  map.addLayer({
    id: "google-layer",
    type: "raster",
    source: "google",
    layout: { visibility: "none" },
  });

  // ---- OPENSTREET ----
  map.addSource("osm", {
    type: "raster",
    tiles: ["https://tile.openstreetmap.org/{z}/{x}/{y}.png"],
    tileSize: 256,
  });

  map.addLayer({
    id: "osm-layer",
    type: "raster",
    source: "osm",
    layout: { visibility: "none" },
  });
  console.log(mapType);

  // ---- GOOGLE SATELLITE ----
  map.addSource("google-satellite", {
    type: "raster",
    tiles: ["https://mt1.google.com/vt/lyrs=y&x={x}&y={y}&z={z}"],
    tileSize: 256,
  });

  map.addLayer({
    id: "google-satellite-layer",
    type: "raster",
    source: "google-satellite",
    layout: { visibility: "none" },
  });

  // ---- GOOGLE TRAFFIC ----
  if (!map.getSource("google-traffic")) {
    map.addSource("google-traffic", {
      type: "raster",

      tiles: [
        // Changed "h,traffic" to just "traffic"
        `https://mt1.google.com/vt?lyrs=h,traffic&x={x}&y={y}&z={z}&key=${config.googleMapKey}`,
      ],

      tileSize: 256,
    });
    // map.addSource("google-traffic", {
    //   type: "raster",
    //   tiles: [
    //     // Changed "h,traffic" to just "traffic" to remove labels
    //     `https://mt1.google.com/vt?lyrs=t@159&x={x}&y={y}&z={z}&key=${config.googleMapKey}`,
    //   ],
    //   tileSize: 256,
    // });
    map.addLayer({
      id: "google-traffic-layer",
      type: "raster",
      source: "google-traffic",
      layout: { visibility: "none" }, // Start hidden
      paint: { "raster-opacity": 1, "raster-resampling": "linear" },
    });
  }

  //switchBase(map,mapType)
};

const GOOGLE_TILE_URL = "mt1.google.com{x}&y={y}&z={z}";
// const unclusteredPointLayer = {
//   id: "vehicles",
//   type: "circle",
//   source: "vehicle-source",
//   filter: ["!", ["has", "point_count"]],
//   paint: {
//     "circle-radius": 6,
//     "circle-color": "#007cbf",
//     "circle-stroke-width": 1,
//     "circle-stroke-color": "#fff",
//   },
// };
const loadWithRetry = async (url, id, retries = 3) => {
  try {
    const res = await fetch(url);

    if (!res.ok) throw new Error(`HTTP ${res.status}`);

    // VALIDATION: Ensure the server is actually sending an image
    const contentType = res.headers.get("content-type");
    if (!contentType || !contentType.startsWith("image/")) {
      throw new Error(`Invalid content-type: ${contentType}`);
    }

    const blob = await res.blob();
    return await createImageBitmap(blob);
  } catch (err) {
    if (retries > 0) {
      // Wait 500ms before retrying to handle temporary network blips
      await new Promise((resolve) => setTimeout(resolve, 500));
      return loadWithRetry(url, id, retries - 1);
    }
    throw err;
  }
};

function switchBase(mapRef, type) {
  const map = mapRef;

  map.setLayoutProperty(
    "google-layer",
    "visibility",
    type === "google" ? "visible" : "none"
  );

  map.setLayoutProperty(
    "osm-layer",
    "visibility",
    type === "openstreet" ? "visible" : "none"
  );

  map.setLayoutProperty(
    "google-satellite-layer",
    "visibility",
    type === "satellite" ? "visible" : "none"
  );

  // map.setLayoutProperty(
  //   "google-traffic-layer",
  //   "visibility",
  //   type === "google-traffic" ? "visible" : "none"
  // );
  // console.log(type, "type");

  // if (type === "google-traffic") {
  //   const currentVisibility = map.getLayoutProperty(
  //     "google-traffic-layer",
  //     "visibility"
  //   );
  //   const newVisibility = currentVisibility === "visible" ? "none" : "visible";
  //   map.setLayoutProperty("google-traffic-layer", "visibility", newVisibility);
  // }
  // Carto = default (both hidden)
}

class LiveTrackingMap extends Component {
  constructor(props) {
    super(props);

    this.state = {
      clickedMarker: null,
      loadData: 1,
      mapType: this.props.mapType,
      viewState: {
        longitude: config.mapCenter[1],// 46.6753,
        latitude: config.mapCenter[0],//24.7136,
        zoom: 6,
      },
    };

    this.liveTrackingStore = new LiveTrackingStore(this);
    if (!maplibregl._googleProtocolAdded) {
      maplibregl.addProtocol("google", googleProtocol);
      maplibregl._googleProtocolAdded = true;
    }

    this.map = null;
  }

  getGoogleStyle = () =>
    createGoogleStyle(
      "google", // sourceId (STRING)
      "roadmap", // mapType
      config.googleMapKey // API key
    );

  buildVehicleGeoJSON = (vehicles = []) => {
    const focusedId = this.props.focusedVehicleId;
    return {
      type: "FeatureCollection",
      features: vehicles
        .filter(
          (v) =>
            v.latitude != null &&
            v.longitude != null &&
            v.vehicleId !== focusedId
        )
        .map((v) => ({
          type: "Feature",
          geometry: {
            type: "Point",
            coordinates: [v.longitude, v.latitude],
          },
          properties: {
            ...v,
            mapImage: v.mapImage,
            diff: moment(v.currtime).diff(v.updatedate, "minutes"),
            rotation: parseFloat(v.direction),
            name:
              this.props.SearchDriverPopup || this.props.ShowNearAssetPopup
                ? v.driverName
                : v.name,
            vehicleNo: v.vehicleNo,
            vehiclestatus: v.vehiclestatus,
          },
        })),
    };
  };

  componentDidMount() {
    // this.map.on("load", () => {
    //   this.loadVehicleIcons();
    // });
    if (this.props.liveTrackingMapRef) {
      this.props.liveTrackingMapRef.current = this;
    }
  }

  loadVehicleIcons = async (map) => {
    const vehicleData = this.props.vehicles;

    const uniqueImages = [...new Set(vehicleData.map((v) => v.mapImage))];

    const imagePromises = uniqueImages.map((imgName) => {
      return new Promise((resolve) => {
        const url = `/vehicle-icons/${imgName}`; // Absolute path to your public folder

        map.loadImage(url, (error, image) => {
          if (!error && image && !map.hasImage(imgName)) {
            map.addImage(imgName, image);
          }
          resolve();
        });
      });
    });

    await Promise.all(imagePromises);
  };

  clearVehiclePopups = () => {
    if (this.vehiclePopups && this.vehiclePopups.length) {
      this.vehiclePopups.forEach((popup) => popup.remove());
    }
    this.vehiclePopups = [];
  };

  loadVehiclePopup = async (map) => {
    // if (
    //   this.props.vehicles &&
    //   this.props.vehicles !== prevProps.vehicles &&
    //   this.mapRef
    // ) {
    if (!map || !this.props.vehicles?.length) return;

    this.clearVehiclePopups();

    this.vehiclePopups = [];

    const vehicleData = this.props.vehicles;

    vehicleData.forEach((vehicle) => {
      // Validation: skip if coordinates are missing
      if (!vehicle.longitude || !vehicle.latitude) return;

      // console.log("first", vehicle.currentStatus);
      const popupClass =
        vehicle.currentStatus == "Running" ? "permanent-tooltip running" : "";

      const popup = new maplibregl.Popup({
        closeButton: false, // Permanent
        closeOnClick: false, // Permanent
        offset: [0, -15], // Position above the point
        className: "permanent-tooltip",
      })
        .setLngLat([vehicle.longitude, vehicle.latitude])
        .setHTML(`<strong >${vehicle.name}</strong>`)
        .addTo(map);

      this.vehiclePopups.push(popup);
    });
    // }
  };

  componentWillUnmount() {
    if (this.map) this.map.remove();

    if (this.props.liveTrackingMapRef) {
      this.props.liveTrackingMapRef.current = null;
    }
  }
  componentDidUpdate(prevProps, prevState) {
    //For History tracking (in info tab) polyline

    if (prevProps.mapType !== this.props.mapType) {
      switchBase(this.mapRef, this.props.mapType);
    }
    if (
      this.props.polylineData &&
      this.props.polylineData !== prevProps.polylineData
    ) {
      this.zoomToPolyline(this.props.polylineData);
    }
    //For History tracking (in info tab) trip-polyline

    if (
      this.props.trackingPolylineData &&
      this.props.trackingPolylineData !== prevProps.trackingPolylineData
    ) {
      this.zoomToPolyline(this.props.trackingPolylineData);
    }

    if (
      this.props.histTrackingOverspeedPolyline &&
      this.props.histTrackingOverspeedPolyline !==
      prevProps.histTrackingOverspeedPolyline
    ) {
      this.zoomToPolyline(this.props.histTrackingOverspeedPolyline);
    }

    if (
      this.props.histTrackingStraightPolyline &&
      this.props.histTrackingStraightPolyline !==
      prevProps.histTrackingStraightPolyline
    ) {
      this.zoomToPolyline(this.props.histTrackingStraightPolyline);
    }
    //Edit Geofence
    const { editingGeofence } = this.props;

    if (editingGeofence && editingGeofence !== prevProps.editingGeofence) {
      if (this.drawRef) {
        this.loadGeofenceIntoDraw(editingGeofence);
      } else {
        this.pendingGeofence = editingGeofence;
      }
    }

    if (
      this.props.straightLineMarkersData &&
      this.props.straightLineMarkersData !==
      prevProps.straightLineMarkersData &&
      this.mapRef
    ) {
      this.loadStraightLineMarkers(this.mapRef);
    }

    if (
      this.props.idleStopMarkersData &&
      this.props.idleStopMarkersData !== prevProps.idleStopMarkersData &&
      this.mapRef
    ) {
      this.idleStopMarkersData(this.mapRef);
    }

    if (
      this.props.fuelMarkersData &&
      this.props.fuelMarkersData !== prevProps.fuelMarkersData &&
      this.mapRef
    ) {
      this.loadFuelMarkers(this.mapRef);
    }

    if (
      this.props.showAllPoiData &&
      this.props.showAllPoiData !== prevProps.showAllPoiData &&
      this.mapRef
    ) {
      this.zoomToPois(this.props.showAllPoiData);
    }

    if (
      this.props.showSearchPoiData &&
      this.props.showSearchPoiData !== prevProps.showSearchPoiData &&
      this.mapRef
    ) {
      this.zoomToPois(this.props.showSearchPoiData);
    }


    // if (
    //   this.props.vehicles &&
    //   this.props.vehicles !== prevProps.vehicles &&
    //   this.mapRef
    // ) {
    //   this.loadVehiclePopup(this.mapRef);
    // }

    // console.log(
    //   this.liveTrackingStore.nearestAssetPopupData,
    //   "nearestAssetPopupData"
    // );
  }

  zoomToPois = (data) => {
    const poiArray = Array.isArray(data) ? data : [data];
    console.log(poiArray, "poiAaaaaaaaa")
    const map = this.mapRef;

    if (!map || !poiArray?.length) return;

    const bounds = new maplibregl.LngLatBounds();

    poiArray.forEach((poi) => {
      if (poi.latitude && poi.longitude) {
        const coords = [
          Number(poi.longitude),
          Number(poi.latitude),
        ];

        bounds.extend(coords);
      }
    });

    // ✅ Single point fix
    if (poiArray.length === 1) {
      const coords = [
        Number(poiArray[0].longitude),
        Number(poiArray[0].latitude),
      ];

      map.flyTo({
        center: coords,
        zoom: 15,
        duration: 800,
      });
      return;
    }

    map.fitBounds(bounds, {
      padding: 60,
      duration: 800,
      maxZoom: 16,
    });
  };
  zoomToPolyline = (geoJson) => {
    const map = this.mapRef;
    if (!map || !geoJson?.geometry?.coordinates?.length) return;

    const coords = geoJson.geometry.coordinates;

    const bounds = coords.reduce(
      (b, coord) => b.extend(coord),
      new maplibregl.LngLatBounds(coords[0], coords[0])
    );

    map.fitBounds(bounds, {
      padding: 60,
      duration: 800,
    });
  };

  addArrowImage = (map) => {
    if (map.hasImage("arrow")) return;

    const img = new Image();
    img.src = "/arrow.svg";
    img.onload = () => {
      if (!map.hasImage("arrow")) {
        map.addImage("arrow", img);
      }
    };
  };

  loadStraightLineMarkers = async (map) => {
    const data = this.props.straightLineMarkersData;
    if (!map || !data || data.type !== "FeatureCollection") return;

    const icons = new Set(
      data.features.map((f) => f?.properties?.icon).filter(Boolean)
    );

    for (const iconName of icons) {
      if (map.hasImage(iconName)) continue;

      const url = `/BaloonIcons/${iconName}.png`;

      try {
        const image = await map.loadImage(url);

        if (!map.hasImage(iconName)) {
          map.addImage(iconName, image.data);
        }
      } catch (err) {
        // ✅ Ignore duplicate-image error safely
        if (!err.message?.includes("already exists")) {
          console.error(`Could not load image ${url}`, err);
        }
      }
    }

    this.markerPopup = new maplibregl.Popup({
      closeButton: false,
      closeOnClick: false,
      offset: 10,
    });

    // 1. Show popup on mouseenter
    map.on("mouseenter", "straight-line-markers", (e) => {
      map.getCanvas().style.cursor = "pointer";

      if (!e.features || e.features.length === 0) return;

      const coordinates = e.features[0].geometry.coordinates.slice();
      const {
        vehicleNo,
        updatedate,
        formatted_address,
        speed,
        emptyWeight,
        activity,
        fromdate,
        todate,
        acc,
        toolTipDta,
      } = e.features[0].properties;

      // Handle map wrap-around
      while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
        coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
      }
      let status = Number(acc) === 1 && Number(speed) > 0;

      const dateSection =
        Number(toolTipDta) === 2 && activity !== "Travel" && !status
          ? `
      <strong>${activity} From:</strong> ${fromdate ? fromdate : "-"}<br/>
      <strong>${activity} To:</strong> ${todate ? todate : "-"}<br/>
    `
          : `
      <strong>Date Time:</strong> ${updatedate ? updatedate : "-"}<br/>
    `;

      const popupContent = `
      <div style="font-size: 12px; padding: 5px;">
        <strong>Vehicle No:</strong> ${vehicleNo ? vehicleNo : "-"}<br/>       
          ${dateSection}
        <strong>Location:</strong> ${formatted_address ? formatted_address : "-"
        }<br/>
        <strong>Speed:</strong> ${speed ? speed : "-"} km/h<br/>
        <strong>Weight:</strong> ${emptyWeight ? emptyWeight : "-"}
      </div>
    `;

      this.markerPopup.setLngLat(coordinates).setHTML(popupContent).addTo(map);
    });

    // 2. Hide popup on mouseleave
    map.on("mouseleave", "straight-line-markers", () => {
      map.getCanvas().style.cursor = "";
      this.markerPopup.remove(); // Removes the popup from the map
    });
  };

  idleStopMarkersData = async (map) => {
    const data = this.props.idleStopMarkersData;
    if (!map || !data || data.type !== "FeatureCollection") return;

    const icons = new Set(
      data.features.map((f) => f?.properties?.icon).filter(Boolean)
    );

    for (const iconName of icons) {
      if (map.hasImage(iconName)) continue;

      const url = `/BaloonIcons/${iconName}.png`;

      try {
        const image = await map.loadImage(url);

        if (!map.hasImage(iconName)) {
          map.addImage(iconName, image.data);
        }
      } catch (err) {
        // ✅ Ignore duplicate-image error safely
        if (!err.message?.includes("already exists")) {
          console.error(`Could not load image ${url}`, err);
        }
      }
    }

    this.markerPopup = new maplibregl.Popup({
      closeButton: false,
      closeOnClick: false,
      offset: 10,
    });

    // 1. Show popup on mouseenter
    map.on("mouseenter", "idle-stop-markers", (e) => {
      map.getCanvas().style.cursor = "pointer";

      if (!e.features || e.features.length === 0) return;

      const coordinates = e.features[0].geometry.coordinates.slice();
      const {
        vehicleNo,
        updatedate,
        formatted_address,
        speed,
        emptyWeight,
        activity,
        fromdate,
        todate,
        acc,
        toolTipDta,
      } = e.features[0].properties;

      // Handle map wrap-around
      while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
        coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
      }
      let status = Number(acc) === 1 && Number(speed) > 0;

      const dateSection =
        Number(toolTipDta) === 2 && activity !== "Travel" && !status
          ? `
      <strong>${activity} From:</strong> ${fromdate ? fromdate : "-"}<br/>
      <strong>${activity} To:</strong> ${todate ? todate : "-"}<br/>
    `
          : `
      <strong>Date Time:</strong> ${updatedate ? updatedate : "-"}<br/>
    `;

      const popupContent = `
      <div style="font-size: 12px; padding: 5px;">
        <strong>Vehicle No:</strong> ${vehicleNo ? vehicleNo : "-"}<br/>       
          ${dateSection}
        <strong>Location:</strong> ${formatted_address ? formatted_address : "-"
        }<br/>
        <strong>Speed:</strong> ${speed ? speed : "-"} km/h<br/>
        <strong>Weight:</strong> ${emptyWeight ? emptyWeight : "-"}
      </div>
    `;

      this.markerPopup.setLngLat(coordinates).setHTML(popupContent).addTo(map);
    });

    // 2. Hide popup on mouseleave
    map.on("mouseleave", "idle-stop-markers", () => {
      map.getCanvas().style.cursor = "";
      this.markerPopup.remove(); // Removes the popup from the map
    });
  };

  loadOverSpeedMarkers = async (map) => {
    try {
      const response = await map.loadImage(
        "/BaloonIcons/Orange-south-east.png"
      );
      const imageData = response.data ? response.data : response;
      if (!map.hasImage("overspeed-marker")) {
        map.addImage("overspeed-marker", imageData);
      }
    } catch (error) {
      console.error("Error loading image:", error);
    }

    // Disable closeButton/closeOnClick for a cleaner hover tooltip experience
    this.markerPopup = new maplibregl.Popup({
      closeButton: false,
      closeOnClick: false,
      offset: 10,
    });

    // 1. Show popup on mouseenter
    map.on("mouseenter", "overspeed-markers", (e) => {
      map.getCanvas().style.cursor = "pointer";

      if (!e.features || e.features.length === 0) return;

      const coordinates = e.features[0].geometry.coordinates.slice();
      const { vehicleNo, speed, speedLimit, updatedate, weight } =
        e.features[0].properties;

      // Handle map wrap-around
      while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
        coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
      }

      const popupContent = `
      <div style="font-size: 12px; padding: 5px;">
        <strong>Vehicle No:</strong> ${vehicleNo ? vehicleNo : "-"}<br/>
        <strong>Speed:</strong> ${speed ? speed : "-"} km/h<br/>
        <strong>Limit:</strong> ${speedLimit ? speedLimit : "-"} km/h<br/>
        <strong>Date Time:</strong> ${updatedate ? updatedate : "-"}<br/>
        <strong>Weight:</strong> ${weight ? weight : "-"}
      </div>
    `;

      this.markerPopup.setLngLat(coordinates).setHTML(popupContent).addTo(map);
    });

    // 2. Hide popup on mouseleave
    map.on("mouseleave", "overspeed-markers", () => {
      map.getCanvas().style.cursor = "";
      this.markerPopup.remove(); // Removes the popup from the map
    });
  };

  loadFuelMarkers = async (map) => {
    try {
      const response = await map.loadImage("/map-car-icon-green.png");
      const imageData = response.data ? response.data : response;
      if (!map.hasImage("map-car-icon-green")) {
        map.addImage("map-car-icon-green", imageData);
      }
    } catch (error) {
      console.error("Error loading image:", error);
    }

    // Disable closeButton/closeOnClick for a cleaner hover tooltip experience
    this.markerPopup = new maplibregl.Popup({
      closeButton: false,
      closeOnClick: false,
      offset: 10,
    });

    // 1. Show popup on mouseenter
    map.on("mouseenter", "fuel-markers", (e) => {
      map.getCanvas().style.cursor = "pointer";

      if (!e.features || e.features.length === 0) return;

      const coordinates = e.features[0].geometry.coordinates.slice();
      const { vehicleNo, location, refillfuel, refillfuellevel } =
        e.features[0].properties;

      // Handle map wrap-around
      while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
        coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
      }

      const popupContent = `
      <div style="font-size: 12px; padding: 5px;">
        <strong>Vehicle No:</strong> ${vehicleNo ? vehicleNo : "-"}<br/>
        <strong>Location:</strong> ${location ? location : "-"} km/h<br/>
        <strong>Refill Fuel:</strong> ${refillfuel ? refillfuel : "-"} km/h<br/>
        <strong>Refill Fuel Level:</strong> ${refillfuellevel ? refillfuellevel : "-"
        }<br/>
      </div>
    `;

      this.markerPopup.setLngLat(coordinates).setHTML(popupContent).addTo(map);
    });

    // 2. Hide popup on mouseleave
    map.on("mouseleave", "fuel-markers", () => {
      map.getCanvas().style.cursor = "";
      this.markerPopup.remove(); // Removes the popup from the map
    });
  };

  loadGeofenceIntoDraw = (val) => {
    if (!this.drawRef) return;

    this.drawRef.deleteAll();

    const { latLngs, shapeType } = this.convertPointsToGeoJSON(val);

    let feature;

    if (shapeType === "polygon" || shapeType === "rectangle") {
      // Ensure polygon is closed
      const closed = [...latLngs, latLngs[0]];

      feature = {
        type: "Feature",
        properties: {
          zoneId: val.zoneId,
        },
        geometry: {
          type: "Polygon",
          coordinates: [closed],
        },
      };
    }

    if (shapeType === "circle") {
      const center = latLngs[0]; // [lng, lat]
      const radiusKm = val.radius / 1000;

      const circlePolygon = turf.circle(center, radiusKm, {
        steps: 16,
        units: "kilometers",
      });

      feature = {
        ...circlePolygon,
        properties: {
          zoneId: val.zoneId,
          shapeType: "circle",
          isCircle: true,
          radiusInKm: radiusKm,
          center,
        },
      };
    }

    const [featureId] = this.drawRef.add(feature);

    this.zoomToFeature(feature);

    // Enable edit mode
    setTimeout(() => {
      // this.drawRef.changeMode("direct_select", { featureId });
      this.drawRef.changeMode("direct_select", {
        featureId,
        // center: feature.properties.center,
        // radiusInKm: feature.properties.radiusInKm,
      });
    }, 100);
  };

  convertPointsToGeoJSON = (val) => {
    console.log(val, "val");
    const pointsArray = val?.points
      .split(",")
      .map(Number)
      .filter((_, index) => index % 3 !== 2);

    const latLngs = [];
    for (let i = 0; i < pointsArray.length; i += 2) {
      latLngs.push([pointsArray[i + 1], pointsArray[i]]); // [lng, lat]
    }

    console.log(latLngs, "latLngs");
    let shapeType = "polygon";
    if (latLngs.length === 1) shapeType = "circle";
    else if (latLngs.length === 2) shapeType = "rectangle";

    return { latLngs, shapeType };
  };

  handleMapClick = (e) => {
    const { lng, lat } = e.lngLat;

    this.setState({
      clickedMarker: { lng, lat },
    });

    if (this.props.onMapClick) {
      this.props.onMapClick(e.lngLat);
    }
  };

  clearGeofencesFromMap = () => {
    // console.log("Clearing geofences");

    if (this.drawRef) {
      this.drawRef.deleteAll();
    }
  };

  // zoomToFeature = (feature) => {
  //   if (!this.mapRef || !feature) return;

  //   let bounds;

  //   if (feature.properties?.shapeType === "circle") {
  //     const center = feature.properties.center; // [lng, lat]
  //     const radiusKm = feature.properties.radiusInKm;

  //     // 🔑 Minimum zoom radius (in km)
  //     const MIN_RADIUS_KM = 0.7; // 300 meters (adjust if needed)

  //     const zoomRadiusKm = Math.max(radiusKm, MIN_RADIUS_KM);

  //     const buffered = turf.buffer(turf.point(center), zoomRadiusKm, {
  //       units: "kilometers",
  //     });

  //     const bbox = turf.bbox(buffered);

  //     bounds = new maplibregl.LngLatBounds(
  //       [bbox[0], bbox[1]],
  //       [bbox[2], bbox[3]]
  //     );
  //   } else {
  //     const bbox = turf.bbox(feature);
  //     bounds = new maplibregl.LngLatBounds(
  //       [bbox[0], bbox[1]],
  //       [bbox[2], bbox[3]]
  //     );
  //   }

  //   this.mapRef.fitBounds(bounds, {
  //     padding: 60,
  //     maxZoom: 14,
  //     duration: 800,
  //   });
  // };

  zoomToFeature = (feature) => {
    if (!this.mapRef || !feature) return;

    let bounds;

    // Use turf bbox for ALL geometry types
    const bbox = turf.bbox(feature);

    bounds = new maplibregl.LngLatBounds(
      [bbox[0], bbox[1]], // southwest
      [bbox[2], bbox[3]] // northeast
    );

    // console.log("Circle bounds:", turf.bbox(feature));

    this.mapRef.fitBounds(bounds, {
      padding: 40,
      maxZoom: 14, // prevents over-zoom (important for circles)
      duration: 800,
    });
  };

  handleMapLoad = (map) => {
    // this.map = map;
    // const pegmanIcon = document.createElement("img");
    // pegmanIcon.src = "🚶"; // add your pegman image
    // pegmanIcon.style.width = "32px";
    // pegmanIcon.style.height = "32px";
    // pegmanIcon.style.cursor = "grab";
    const pegmanEl = document.createElement("div");
    pegmanEl.className = "pegman";
    pegmanEl.innerText = "🚶"; // emoji works here
    pegmanEl.style.cursor = "grab";
    const pegmanMarker = new maplibregl.Marker({
      element: pegmanEl,
      draggable: true,
    })
      .setLngLat(map.getCenter())
      .addTo(map);

    pegmanMarker.on("dragend", () => {
      const { lng, lat } = pegmanMarker.getLngLat();
      this.openStreetView(lng, lat);
    });
  };

  openStreetView = (lng, lat) => {
    // const url = `https://www.google.com/maps/embed/v1/streetview
    // ?key=${config.googleMapKey}
    // &location=${lat},${lng}
    // &heading=210
    // &pitch=10
    // &fov=80`;

    const url = `https://www.google.com/maps/embed/v1/streetview?key=${config.googleMapKey}&location=${lat},${lng}&heading=210&pitch=10&fov=80`;

    this.setState({
      streetViewUrl: url,
      showStreetView: true,
    });
  };

  // handleMapLoad = (map) => {
  //   // const map = e.target; // MapLibre GL JS instance

  //   const streetView = new StreetViewControl({
  //     googleApiKey: config.googleMapKey,
  //     defaultProvider: "google",
  //     showPegmanButton: true,

  //     enablePegmanDrag: true,
  //     collapsed: false,
  //   });

  //   map.addControl(streetView, "bottom-right");

  //   map.on("mouseup", () => {
  //     document
  //       .querySelector(".maplibre-google-streetview-panel")
  //       ?.classList.add("active");
  //   });
  // };

  // buildPoiGeoJSON = (data) => {
  //   const poiArray = Array.isArray(data) ? data : [data];

  //   return {
  //     type: "FeatureCollection",
  //     features: poiArray
  //       .filter(
  //         (v) =>
  //           v.latitude != null &&
  //           v.longitude != null
  //       )
  //       .map((v) => ({
  //         type: "Feature",
  //         geometry: {
  //           type: "Point",
  //           coordinates: [v.longitude, v.latitude],
  //         },
  //         properties: {
  //           ...v,
  //           poitext: v.poiText,
  //           mapImage: v.Photo || 'person-fill.png',

  //         },
  //       })),
  //   };
  // }

  buildPoiGeoJSON = (data) => {
    if (data) {
      const poiArray = Array.isArray(data) ? data : [data];

      const offsetStep = 0.00005; // small shift

      return {
        type: "FeatureCollection",
        features: poiArray
          .filter((v) => v.latitude != null && v.longitude != null)
          .map((v, index) => {
            const lat = Number(v.latitude);
            const lng = Number(v.longitude);

            return {
              type: "Feature",
              geometry: {
                type: "Point",
                coordinates: [
                  lng + index * offsetStep,   // shift longitude
                  lat + index * offsetStep,   // shift latitude
                ],
              },
              properties: {
                ...v,
                poitext: v.poiText,
                mapImage: v.Photo || "person-fill.png",
              },
            };
          }),
      };
    }

  };
  render() {
    const vehicleGeoJSON = this.buildVehicleGeoJSON(this.props.vehicles);
    //    console.log(this.props.vehicles);

    const searchAssetData = this.buildVehicleGeoJSON(
      this.props.searchAssetData
    );

    const searchDriverData = this.buildVehicleGeoJSON(
      this.props.searchDriverData
    );

    const nearestAssetData = this.buildVehicleGeoJSON(
      this.props.showNearestVehiclesData
    );

    const showAllPoiData = this.buildPoiGeoJSON(this.props.showAllPoiData)

    const searchPoiData = this.buildPoiGeoJSON(this.props.showSearchPoiData)
    const isClusterEnabled = this.props.getUserData()?.mapSetting === "1";


    // console.log(this.props.isPlottingVehicles, "this.props.isPlottingVehicles");
    return (
      <>
        <Spin
          spinning={this.props.isPlottingVehicles}
          wrapperClassName={
            this.props.isSchoolDashboard ? "" : "map-spin-center"
          }
        >
          <Map
            // key={this.props.liveTrackingMainModal ? "selected" : "default"}
            mapLib={maplibregl}
            onLoad={(e) => {
              const map = e.target;
              this.mapRef = map;

              onMapLoad(map, this.props.mapType);

              // map.addSource("traffic", {
              //   type: "vector",
              //   url: "mapbox://mapbox.mapbox-traffic-v1",
              // });

              // map.addLayer({
              //   id: "traffic-layer",
              //   type: "line",
              //   source: "traffic",
              //   "source-layer": "traffic",
              //   paint: {
              //     "line-color": [
              //       "match",
              //       ["get", "congestion"],
              //       "low",
              //       "#2DC4B2",
              //       "moderate",
              //       "#F1F075",
              //       "heavy",
              //       "#F28CB1",
              //       "severe",
              //       "#E55E5E",
              //       "#2DC4B2",
              //     ],
              //     "line-width": 2,
              //   },
              // });

              if (!map.getSource("focusedVehicle")) {
                map.addSource("focusedVehicle", {
                  type: "geojson",
                  data: {
                    type: "Feature",
                    geometry: {
                      type: "Point",
                      coordinates: [0, 0],
                    },
                  },
                });

                map.addLayer({
                  id: "focusedVehicleLayer",
                  type: "symbol",
                  source: "focusedVehicle",
                  layout: {
                    "icon-image": ["get", "mapImage"],

                    // "icon-image": "car-icon",
                    "icon-size": 0.5,
                    "icon-allow-overlap": true,
                    "icon-ignore-placement": true,
                    "icon-rotate": ["get", "rotation"],
                    "icon-rotation-alignment": "map",
                  },
                });
              }

              // loadClusterImages(map);

              //loadClusterImages(map);

              //to set map type like google openstreet
              // this.handleMapLoad(map);
              // map.addControl(new PegmanControl(), "bottom-right");
              const hoverPopup = new maplibregl.Popup({
                closeButton: false, // Cleaner look for hover
                closeOnClick: false,
                offset: [0, -5],
              });

              const pendingImages = new Set();
              const CLUSTER_IDS = new Set([
                "1.png",
                "2.png",
                "3.png",
                "4.png",
                "5.png",
                "6.png",
                "7.png",
                "8.png",
                "9.png",
                "10.png",
                "11.png",
                "12.png",
                "13.png",
                "14.png",
                "15.png",
                "nodata.png",
              ]);
              map.on("idle", () => moveVehiclesToTop(map));
              map.on("styleimagemissing", (e) => {
                const id = e.id;
                console.log(id, "id")
                if (map.hasImage(id)) return;
                // console.log(id)
                let url = BALLOON_ICON_SET.has(id)
                  ? `/BaloonIcons/${id}`
                  : CLUSTER_IDS.has(id)
                    ? `${window.location.origin
                    }/clusterimages/${id}?v=${Date.now()}`
                    : `/vehicle-icons/${id}`;
                // console.log(id,url)
                //  if (CLUSTER_IDS.has(id)) {
                //    url = `${window.location.origin}/clusterimages/${id}?v=${Date.now()}`;
                //  }

                loadWithRetry(url, id)
                  .then((bitmap) => {
                    if (!map.hasImage(id)) {
                      // pixelRatio: 2 helps icons look sharp like Google Maps on mobile/retina
                      map.addImage(id, bitmap, {
                        pixelRatio: window.devicePixelRatio || 1,
                      });
                    }
                  })
                  .catch((err) => {
                    console.error(`Failed to load ${url} after retries:`, err);
                    // Fallback: Add a 1x1 transparent pixel so MapLibre stops firing "missing" event
                    const placeholder = new Uint8Array([0, 0, 0, 0]);
                    if (!map.hasImage(id)) {
                      map.addImage(id, {
                        width: 1,
                        height: 1,
                        data: placeholder,
                      });
                    }
                  });
              });

              // Ensure 'vehicles' matches the ID in searchAssetLayer.id
              map.on("mouseenter", "vehicles", (e) => {
                map.getCanvas().style.cursor = "pointer";
                // Get the click location and vehicle properties
                const coordinates = e.features[0].geometry.coordinates.slice();
                const { mapImage, vehicleNo, name, currentStatus } =
                  e.features[0].properties;

                const statusClass =
                  currentStatus === "Running"
                    ? "running"
                    : currentStatus === "Idle"
                      ? "idle"
                      : currentStatus === "Stopped"
                        ? "stopped"
                        : currentStatus === "No Data"
                          ? "inactive"
                          : "";
                hoverPopup
                  .setLngLat(coordinates)
                  .setHTML(
                    `<div class="hover-tooltip ${statusClass}">

                <!-- Text format: vehicleNo/name -->
                ${vehicleNo || "-"}/${name || "-"}
              </div>`
                  )
                  .addTo(map);
              });

              map.on("mouseleave", "vehicles", () => {
                map.getCanvas().style.cursor = "";
                hoverPopup.remove();
              });

              map.on("mouseenter", "focusedVehicleLayer", (e) => {
                map.getCanvas().style.cursor = "pointer";
                // Get the click location and vehicle properties
                const coordinates = e.features[0].geometry.coordinates.slice();
                const { mapImage, vehicleNo, name, currentStatus } =
                  e.features[0].properties;

                const statusClass =
                  currentStatus === "Running"
                    ? "running"
                    : currentStatus === "Idle"
                      ? "idle"
                      : currentStatus === "Stopped"
                        ? "stopped"
                        : currentStatus === "No Data"
                          ? "inactive"
                          : "";
                hoverPopup
                  .setLngLat(coordinates)
                  .setHTML(
                    `<div class="hover-tooltip ${statusClass}">

                <!-- Text format: vehicleNo/name -->
                ${vehicleNo || "-"}/${name || "-"}
              </div>`
                  )
                  .addTo(map);
              });

              map.on("mouseleave", "focusedVehicleLayer", () => {
                map.getCanvas().style.cursor = "";
                hoverPopup.remove();
              });

              map.on("click", (e) => {
                const features = map?.queryRenderedFeatures(e.point, {
                  layers: ["clusters"],
                });

                if (!features.length) return;

                const feature = features[0];
                const coordinates = feature.geometry.coordinates;

                const currentZoom = map.getZoom();
                const targetZoom = Math.min(currentZoom + 2, 18); // 👈 manual split

                map.easeTo({
                  center: coordinates,
                  zoom: targetZoom,
                  duration: 500,
                });
              });

              // map.addControl(new PegmanControl(map), "bottom-right");

              map.moveLayer("clusters");
              map.moveLayer("cluster-count");

              this.loadVehicleIcons(map);

              // this.loadVehiclePopup(map);

              this.props.loadSearchVehicleIcon();

              this.props.onMapLoad?.(map);

              // Listen for missing images
              if (map.isStyleLoaded()) {
                this.addArrowImage(map);
              } else {
                map.once("styledata", () => {
                  this.addArrowImage(map);
                });
              }

              this.loadOverSpeedMarkers(map);
            }}
            {...this.state.viewState}
            onMove={(e) => this.setState({ viewState: e.viewState })}
            style={{
              position:
                this.props.isTrackingDashboard !== undefined
                  ? "relative"
                  : "sticky", //sticky"
              height:
                this.props.isSchoolDashboard
                  ? "63vh"
                  : this.props.isTrackingDashboard !== undefined ? "64vh" : "92vh",
              borderRadius: this.props.isSchoolDashboard ? "10px" : "0px",

              // width: "100wh",
              width:
                this.props.closeCard === false
                  ? "100%"
                  : this.props.liveTrackingMainModal === true
                    ? "73%"
                    : "100%",
              float: this.props.liveTrackingMainModal
                ? this.context.locale.language === "arabic"
                  ? "right" // push map to right if drawer is on left
                  : "left" // push map to left if drawer is on right
                : "none",
            }}
            // mapStyle={
            //   this.props.mapType === "google"
            //     ? this.getGoogleStyle() :
            //   this.props.mapType === "openstreet" ? "https://tiles.openfreemap.org/styles/liberty" :
            //   "https://basemaps.cartocdn.com/gl/voyager-gl-style/style.json"
            //
            mapStyle="https://basemaps.cartocdn.com/gl/voyager-gl-style/style.json"
            onClick={(e) => {
              const feature = e.features?.[0];

              if (
                !this.props.SearchAssetPopup &&
                !this.props.SearchDriverPopup &&
                !this.props.ShowNearAssetPopup &&
                this.props.showAllPoiData?.length === 0 &&
                this.props.showSearchPoiData?.length === 0 &&
                feature
              ) {
                this.props.onVehicleClick(feature.properties);
              }
              console.log(this.props.showSearchPoiData, "this.props.showSearchPoiData")
              if ((this.props.showAllPoiData && this.props.showAllPoiData?.length > 0
                || this.props.showSearchPoiData && this.props.showSearchPoiData?.length > 0) &&
                feature) {
                this.props.onPoiClick(feature?.properties)
              }
              if (this.props.ShowNearAssetPopup) {
                this.handleMapClick(e);
              }
            }}
            interactiveLayerIds={["vehicles", "focusedVehicleLayer", "pois"]}
          >
            <NavigationControl
              showCompass={false}
              showZoom={true}
              position="bottom-right"
            />
            <FullscreenControl position="bottom-right" />

            {/* <Button
              onClick={() => this.setState({ mapType: "google-traffic" })}
            >
              Toggle Traffic
            </Button> */}

            <Source
              id="vehicle-source"
              type="geojson"
              data={vehicleGeoJSON}
              cluster={isClusterEnabled}
              clusterMaxZoom={10}
              clusterRadius={40}
              clusterProperties={{
                stopped: [
                  "+",
                  ["case", ["==", ["to-number", ["get", "acc"]], 0], 1, 0],
                ],

                idle: [
                  "+",
                  [
                    "case",
                    [
                      "all",
                      ["==", ["to-number", ["get", "acc"]], 1],
                      [
                        "==",
                        ["to-number", ["coalesce", ["get", "speed"], 0]],
                        0,
                      ],
                      ["<", ["get", "diff"], 90],
                    ],
                    1,
                    0,
                  ],
                ],

                running: [
                  "+",
                  [
                    "case",
                    [
                      "all",
                      ["==", ["to-number", ["get", "acc"]], 1],
                      [
                        ">",
                        ["to-number", ["coalesce", ["get", "speed"], 0]],
                        0,
                      ],
                      ["<", ["get", "diff"], 90],
                    ],
                    1,
                    0,
                  ],
                ],

                nodata: ["+", ["case", [">=", ["get", "diff"], 90], 1, 0]],
              }}
            >
              {/* <Layer {...vehicleLayer} /> */}
              <Layer {...unclusteredPointLayer} />
              {isClusterEnabled && (
                <>
                  {" "}
                  <Layer {...clusterLayer} />
                  <Layer {...clusterCountLayer} />
                </>
              )}
            </Source>

            {this.props.SearchAssetPopup && (
              <Source id="vehicle-source" type="geojson" data={searchAssetData}>
                <Layer {...searchAssetLayer} />
              </Source>
            )}

            {this.props.SearchDriverPopup && (
              <Source
                id="vehicle-source"
                type="geojson"
                data={searchDriverData}
              >
                <Layer {...searchAssetLayer} />
              </Source>
            )}

            {this.props.ShowNearAssetPopup && (
              <Source
                id="vehicle-source"
                type="geojson"
                data={nearestAssetData}
              >
                <Layer {...searchAssetLayer} />
              </Source>
            )}
            {/* this.props.showAllPoi && */}
            {this.props.showAllPoiData?.length > 0 && (

              <Source
                id="poi-source"
                type="geojson"
                data={showAllPoiData}
              >
                <Layer {...poiLayer} />
              </Source>
            )}
            {/* this.props.searchPoi */}
            {searchPoiData?.features?.length > 0 && (
              <Source
                id="poi-source"
                type="geojson"
                data={searchPoiData}
              >
                <Layer {...poiLayer} />
              </Source>
            )}

            {this.mapRef && this.props.showGeofenceIcons && (
              <DrawControl
                map={this.mapRef}
                position="top-left"
                displayControlsDefault={false}
                controls={{
                  polygon: true,
                  trash: true,
                }}
                onDrawReady={(draw) => {
                  this.drawRef = draw;
                  console.log(this.props.editingGeofence);

                  if (this.pendingGeofence) {
                    this.loadGeofenceIntoDraw(this.pendingGeofence);
                    this.pendingGeofence = null;
                  }
                }}
                onGeofenceCreate={this.props.onGeofenceCreate}
                onGeofenceUpdate={this.props.onGeofenceUpdate}
                geofenceformRef={this.props}
              />
            )}

            {this.props.polylineData && (
              <Source
                id="vehicle-route"
                type="geojson"
                data={this.props.polylineData}
              >
                <Layer
                  id="vehicle-route-line"
                  type="line"
                  paint={{
                    "line-color": "grey",
                    "line-width": 4,
                  }}
                />
                <Layer
                  id="vehicle-route-arrows"
                  type="symbol"
                  layout={{
                    "symbol-placement": "line",
                    "symbol-spacing": 40, // distance between arrows
                    "icon-image": "arrow",
                    "icon-size": 0.4,
                    "icon-allow-overlap": true,
                    "icon-ignore-placement": true,
                    "icon-rotation-alignment": "map",
                  }}
                />
              </Source>
            )}

            {this.props.trackingPolylineData && (
              <Source
                id="vehicle-route-tracking"
                type="geojson"
                data={this.props.trackingPolylineData}
              >
                <Layer
                  id="vehicle-route-tracking-line"
                  type="line"
                  paint={{
                    "line-color": "#37d5ed",
                    "line-width": 4,
                  }}
                />
              </Source>
            )}

            {this.props.histTrackingOverspeedPolyline && (
              <Source
                id="vehicle-route-overspeed"
                type="geojson"
                data={this.props.histTrackingOverspeedPolyline}
              >
                <Layer
                  id="vehicle-route-overspeed-line"
                  type="line"
                  paint={{
                    "line-color": "green",
                    "line-width": 4,
                  }}
                />
                <Layer
                  id="vehicle-route-overspeed-arrows"
                  type="symbol"
                  layout={{
                    "symbol-placement": "line",
                    "symbol-spacing": 50, // ≈ arrow frequency
                    "icon-image": "arrow",
                    "icon-size": 0.4, // ≈ size: "6px"
                    "icon-rotation-alignment": "map",
                    "icon-allow-overlap": true,
                    "icon-ignore-placement": true,
                  }}
                />
              </Source>
            )}

            {this.props.overspeedMarkersData && (
              <Source
                id="overspeed-points"
                type="geojson"
                data={this.props.overspeedMarkersData}
              >
                <Layer
                  id="overspeed-markers"
                  type="symbol"
                  layout={{
                    "icon-image": "overspeed-marker",
                    "icon-size": 0.7,
                    "icon-allow-overlap": true,
                    "icon-ignore-placement": true,
                    "icon-rotation-alignment": "map",
                    "icon-anchor": "bottom",
                  }}
                />
              </Source>
            )}

            {this.props.fuelMarkersData && (
              <Source
                id="fuel-points"
                type="geojson"
                data={this.props.fuelMarkersData}
              >
                <Layer
                  id="fuel-markers"
                  type="symbol"
                  layout={{
                    "icon-image": "map-car-icon-green",
                    "icon-size": 0.7,
                    "icon-allow-overlap": true,
                    "icon-ignore-placement": true,
                    "icon-rotation-alignment": "map",
                    "icon-anchor": "bottom",
                  }}
                />
              </Source>
            )}

            {/* {this.props.idleStopMarkersData && (
            <Source
              id="idle-stop-points"
              type="geojson"
              data={this.props.idleStopMarkersData}
            >
              <Layer
                id="idle-stop-markers"
                type="symbol"
                layout={{
                  "icon-image": ["get", "icon"],
                  "icon-size": 0.7,
                  "icon-allow-overlap": true,
                  "icon-ignore-placement": true,
                  "icon-rotation-alignment": "map",
                  "icon-anchor": "bottom",
                }}
              />
            </Source>
          )} */}

            {this.props.straightLineMarkersData && (
              <Source
                id="straight-line-points"
                type="geojson"
                data={this.props.straightLineMarkersData}
              >
                <Layer
                  id="straight-line-markers"
                  type="symbol"
                  layout={{
                    "icon-image": ["get", "icon"],
                    "icon-size": 0.7,
                    "icon-allow-overlap": true,
                    "icon-ignore-placement": true,
                    "icon-rotation-alignment": "map",
                    "icon-anchor": "bottom",
                  }}
                />
              </Source>
            )}

            {this.props.histTrackingStraightPolyline && (
              <Source
                id="vehicle-route-straight"
                type="geojson"
                data={this.props.histTrackingStraightPolyline}
              >
                <Layer
                  id="vehicle-route-straight-line"
                  type="line"
                  paint={{
                    "line-color": "blue",
                    "line-width": 4,
                  }}
                />
              </Source>
            )}

            {this.state.clickedMarker && this.props.ShowNearAssetPopup && (
              <Marker
                longitude={this.state.clickedMarker.lng}
                latitude={this.state.clickedMarker.lat}
                anchor="bottom"
              >
                <img
                  src={locationPin}
                  alt="location"
                  style={{
                    width: 30,
                    height: 30,
                    cursor: "pointer",
                  }}
                />
              </Marker>
            )}
            {/* 
            {console.log(this.state.streetViewUrl, "this.state.streetViewUrl")}
            {this.state.showStreetView && (
              <div className="streetview-panel">
                <iframe
                  title="Street View"
                  width="100%"
                  height="100%"
                  loading="lazy"
                  allowFullScreen
                  src={this.state.streetViewUrl}
                />
                <button
                  onClick={() => this.setState({ showStreetView: false })}
                >
                  ✕
                </button>
              </div>
            )} */}

            {/* <PegmanControl /> */}
          </Map>
        </Spin>
      </>
    );
  }
}

LiveTrackingMap.contextType = StoreContext;
export default observer(withRouter(LiveTrackingMap));
